import { makeStyles } from '@material-ui/core/styles';

export const useSideBarButtonStyles = makeStyles(() => ({
    iconButton: {
        height: '24px',
        marginRight: '8px'
    },
    containerButton: {
        display: 'flex',
        alignItems: 'center',
    }
}));
